module.exports = __webpack_public_path__ + "assets/icon-templates.67c4492f.svg";